<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16 2v2h-1v3.243a8 8 0 0 0 .736 3.352l4.282 9.276A1.5 1.5 0 0 1 18.656 22H5.344a1.5 1.5 0 0 1-1.362-2.129l4.282-9.276A8 8 0 0 0 9 7.243V4H8V2h8zm-2.612 8.001h-2.776a10 10 0 0 1-.374 1.071l-.158.361L6.125 20h11.749l-3.954-8.567a10 10 0 0 1-.532-1.432zM11 7.243a10 10 0 0 1-.029.758h2.058a10 10 0 0 1-.021-.364L13 7.243V4h-2v3.243z"/></svg>
</template>

<script>
export default {
    name: 'IngredientsIcon',
};
</script>
